import { __assign } from "tslib";
import { getFocusStyle } from 'office-ui-fabric-react/lib/Styling';
export var CommandBarButtonStyles = function (props) {
    var theme = props.theme;
    if (!theme) {
        throw new Error('Theme is undefined or null.');
    }
    return {
        root: __assign({}, getFocusStyle(theme, { inset: 2 })),
    };
};
//# sourceMappingURL=CommandBarButton.styles.js.map